import { createContext } from 'react'
import { Socket } from 'socket.io-client'

export interface ChatContextProps {
  socket: Socket
}

export const ChatContext = createContext<ChatContextProps | null>(null)
